import type { ComponentProps } from "react";

import { hubViewportTableCardClassName, type HubViewportChrome } from "@/lib/hubLayoutClassNames";
import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/Card";

export function HubViewportCard({
  chrome = "standard",
  className,
  ...rest
}: ComponentProps<typeof Card> & {
  chrome?: HubViewportChrome;
}) {
  return <Card className={cn(hubViewportTableCardClassName(chrome), className)} {...rest} />;
}
